import styled from 'styled-components'

export const ItemContainer = styled.div`
  display: flex;
  background-color: ${props => props.backgroundColor};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  padding: ${props => `${props.theme.spacing.sp8} ${props.theme.spacing.sp16} ${props.theme.spacing.sp16}`};
`

export const IdentifierContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${props => props.theme.spacing.sp16};
  padding-left: 0px;
  border-right: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  margin-right: ${props => props.theme.spacing.sp16};
  min-width: 50px;
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
  width: calc(100% - 5.25rem);
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const NameContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
`
